// Colorado College's majors (lane 2, #2745). Read on 2026-10-01 from CC's official
// Majors and Minors page (coloradocollege.edu/academics/dept/majors), which links each
// major to its Catalog of Courses entry. The page names no degree type, so none is shown.
// The Independently Designed Major, minors and thematic minors are left out.
const majors = {
    "slug": "colorado-college",
    "read": "2026-10-01",
    "intro": "Every major on Colorado College's official Majors and Minors page. You may also design your own major; minors are left out.",
    "groups": [
        {
            "name": "Majors",
            "source": {
                "label": "Colorado College, Majors and Minors",
                "url": "https://www.coloradocollege.edu/academics/dept/majors/index.html"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Art",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Business, Economics, and Society (BESoc)",
                    "degree": null
                },
                {
                    "name": "Chemistry and Biochemistry",
                    "degree": null
                },
                {
                    "name": "Classics",
                    "degree": null
                },
                {
                    "name": "Classics-English",
                    "degree": null
                },
                {
                    "name": "Classics-History-Politics",
                    "degree": null
                },
                {
                    "name": "Comparative Literature",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Studies and Science",
                    "degree": null
                },
                {
                    "name": "Feminist and Gender Studies",
                    "degree": null
                },
                {
                    "name": "Film and Media Studies",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Geology",
                    "degree": null
                },
                {
                    "name": "German",
                    "degree": null
                },
                {
                    "name": "Hispanic Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History-Philosophy",
                    "degree": null
                },
                {
                    "name": "History-Political Science",
                    "degree": null
                },
                {
                    "name": "International Political Economy",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Mathematical Economics",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Molecular Biology",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Organismal Biology and Ecology",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Race, Ethnicity, and Migration Studies",
                    "degree": null
                },
                {
                    "name": "Religion, Culture, Power",
                    "degree": null
                },
                {
                    "name": "Russian and Eurasian Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Southwest Studies",
                    "degree": null
                },
                {
                    "name": "Theatre and Dance",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
